import { Box, Button, Grid, Link, Typography } from '@mui/material';
import { useState } from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { useNavigate } from 'react-router-dom';
import ButtonCTAOnboarding from './components/ButtonCTAOnboarding';
import TestimonialsCarousel from './components/TestimonialsCarousel';

export const ConfirmPhoneOnboarding = () => {
  const [phoneNumber, setPhoneNumber] = useState<string | undefined>(undefined);
  const navigate = useNavigate();

  const handleGoToNextPage = () => {
    navigate('/onboarding/v2/confirm-phone-code');
  };

  return (
    <Grid container sx={{ minHeight: '100vh' }}>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: '#19191C',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
        }}
      >
        <Box
          sx={{
            mx: 'auto',
            maxWidth: 400,
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <img
            src="/icon/artwork.svg"
            alt="Oppy's AI assistants handle your daily tasks…"
            style={{
              width: 180,
              height: 'auto',
            }}
          />
          <Typography
            color="#fff"
            fontFamily="Space Grotesk"
            variant="h6"
            mt={2}
            mb={4}
            fontWeight={400}
          >
            Sign in to Oppy dashboard
          </Typography>
          <Box sx={{ width: '100%', mb: 3 }}>
            <Typography
              variant="subtitle1"
              sx={{
                mb: 2,
                color: '#fff',
                fontWeight: 400,
                fontSize: 16,
                fontFamily: 'Space Grotesk',
              }}
            >
              Phone number
            </Typography>
            <Box
              sx={{
                '& .PhoneInput': {
                  width: '100%',
                  border: '1px solid #fff',
                  borderRadius: '8px',
                  transition: 'border-color 0.2s',
                  backgroundColor: 'transparent',
                },
                '& .PhoneInputInput': {
                  flex: '1',
                  border: 'none',
                  outline: 'none',
                  height: '48px',
                  paddingLeft: '12px',
                  fontSize: '1rem',
                  color: '#fff',
                  backgroundColor: 'transparent',
                  '::placeholder': {
                    color: '#BDBDBD',
                    opacity: 1,
                  },
                },
                '& .PhoneInputCountry': {
                  display: 'flex',
                  alignItems: 'center',
                  margin: '0 12px',
                },
                '& .PhoneInputCountrySelectArrow': {
                  display: 'none',
                },
              }}
            >
              <PhoneInput
                placeholder="+1 (123) 123-1234"
                value={phoneNumber}
                onChange={setPhoneNumber}
                international
                countryCallingCodeEditable={false}
                defaultCountry="US"
              />
            </Box>
          </Box>

          <ButtonCTAOnboarding
            label="Send verification code"
            onClick={handleGoToNextPage}
          />

          <Button
            variant="text"
            sx={{
              mt: 2,
              width: '100%',
              color: '#4949C8',
              fontWeight: '100',
              textTransform: 'none',
              fontSize: 16,
              fontFamily: 'Space Grotesk',
            }}
          >
            Sign in using email
          </Button>
          <Typography
            variant="body2"
            mt={3}
            textAlign="center"
            color="#fff"
            fontSize={16}
            fontWeight={400}
            fontFamily="Space Grotesk"
          >
            Don't have an account yet?{' '}
            <Link href="#" color="#4949C8" underline="hover">
              Start a free trial
            </Link>
          </Typography>
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: '#fafafd',
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box sx={{ maxWidth: 500, textAlign: 'center', mb: 0 }}>
          <Typography
            variant="h5"
            fontFamily="Space Grotesk"
            fontWeight={700}
            color="#4949C8"
            sx={{ mb: 1 }}
          >
            Oppy's AI assistants handle <br /> your daily tasks…
          </Typography>
          <Typography variant="subtitle1" color="#222" sx={{ mb: 4 }}>
            so you can focus on showing homes, closing <br /> deals, and
            building relationships.
          </Typography>
        </Box>
        <TestimonialsCarousel />
      </Grid>
    </Grid>
  );
};

export default ConfirmPhoneOnboarding;
